import { render, staticRenderFns } from "./ProductCopy.vue?vue&type=template&id=ba77b638"
import script from "./ProductCopy.vue?vue&type=script&lang=js"
export * from "./ProductCopy.vue?vue&type=script&lang=js"
import style0 from "./ProductCopy.vue?vue&type=style&index=0&id=ba77b638&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports